import React from "react";
import {
  Form,
  Input,
  Ref,
  Dimmer,
  Loader
} from "semantic-ui-react";
import defaultTo from "lodash/defaultTo";
import readXlsxFile from "read-excel-file";
import ImportModal from "./ImportModal";
import { setSharedState } from "../../utilities/sharedState";
import { Redirect } from "react-router-dom";
import {
  createMapping,
  getColumnHeadersFromWorksheet
} from "../../utilities/worksheet";
import {
  getSellingDiv,
  getDepartments,
  getVendors,
  getPreferredTicketType,
  postCdpDates
} from "../../services/offpriceServices";
import { skipColum, cdpColumns } from "../../utilities/columnNames";
import { css } from "emotion";
import sortBy from "lodash/sortBy";
import _ from "lodash";
import DatePicker from "react-datepicker";
import { toast } from "../../utilities/toast";
import moment from "moment";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

export default class CreateCdpOrder extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      showImportModal: false,
      excelRows: [],
      loading: false,
      goToProductDetail: false,
      mappings: [],
      response: "",
      sellingDivisionsOptions: [],
      buyingDivisionsOptions: [],
      calenderVal: '',
      department: null,
      vendor: null,
      departments: [],
      vendors: [],
      dataHasBeenModified: false,
      ticketTypeCode: null
    };
    this.buyingSellingDiv = [];
    this.sellingopdivnumber = 0;
    this.sellingDivVal = "MCY";
    this.buyingDivVal = "MBK";
    this.cdpDateObj = [];
    this.cdpSelectedDateObj = [];
  }

  componentDidMount() {
    this.getSellingDivOptions();
    this.loadDept_Vendor();
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    delete this.fileRef;
  }

  handleReadFile = e => {
    this.setState(state => ({
      ...state,
      loading: true
    }));

    readXlsxFile(e.target.files[0]).then(rows => {
      this.fileRef.value = null;
      // create automapping
      const headers = getColumnHeadersFromWorksheet(rows);
      const autoMappings = createAutoMappings(headers, cdpColumns);

      this.setState(state => ({
        ...state,
        loading: false,
        showImportModal: true,
        excelRows: rows,
        mappings: autoMappings
      }));
    });
  };

  handleRef = ref => {
    if (!this.fileRef) {
      if (ref) this.fileRef = ref.children[0];
    }
  };

  handleImportCancellation = () => {
    this.setState(state => ({
      ...state,
      excelRows: [],
      showImportModal: false
    }));
  };

  handleImport = () => {
    const excelRows = this.state.excelRows;
    const mappings = this.state.mappings;
    this.setState(
      state => ({
        ...state,
        excelRows: [],
        showImportModal: false,
        goToProductDetail: true
      }),
      () => {
        // move excel rows and mappings to the shared state
        // to make it visible for product detail view
        setSharedState({
          importedExcelRows: excelRows,
          importedExcelMappings: mappings
        });
      }
    );
  };

  handleAddMapping = (from, to) => {
    this.setState(state => {
      const nextMapping = createMapping(from, to);
      const cleanMappings = state.mappings.filter(mapping => {
        if (nextMapping.from === mapping.from) {
          return false;
        }
        if (mapping.to === skipColum.value) {
          return false;
        }
        if (mapping.to === nextMapping.to) {
          return false;
        }
        return true;
      });

      const nextMappings = [...cleanMappings, nextMapping];

      return {
        mappings: nextMappings
      };
    });
  };

  cdpDateCalculation = (date, dateString) => {
    let currDate = new Date();
    let nextMonthDate = new Date();
    nextMonthDate.setMonth(Number(currDate.getMonth()+1));
    let cdpDateCalculation = this.cdpDateObj
        .filter(obj => obj.CDPCycleDate === dateString);
        this.cdpSelectedDateObj = cdpDateCalculation;
    if(cdpDateCalculation.length) {
      var deadlineDate = new Date(cdpDateCalculation[0].EntryDeadlineDate);
      if (deadlineDate >= currDate) this.setState({ calenderVal: date });
      else this.setState({ calenderVal: nextMonthDate }); 
    } else {
      this.setState({ calenderVal: nextMonthDate });
    } 
  }

  handleDateChange = date => {
    const currDate = new Date();
    let dateString ='';
    let currentMonthFirstDay = new Date().setDate(1);
    if (date >= currDate) {
      dateString = moment(date).format('YYYY-MM-DD');
      this.cdpDateCalculation(date, dateString);
    }
    else {
      dateString = moment(currentMonthFirstDay).format('YYYY-MM-DD');
      this.cdpDateCalculation(currentMonthFirstDay, dateString);
    }    
  };

  handleSellingDivChange = (e, { value }) => {
    let buyingDivision = this.buyingSellingDiv
      .filter(
        obj =>
          obj.RowKey ===
          this.state.sellingDivisionsOptions[Number(value)].rowkeytext
      )
      .map((obj, index) => {
        let newObj = {};
        newObj.value = index;
        newObj.key = index;
        newObj.rowkeytext = obj.PartitionKey;
        newObj.text = obj.BuyingDivName;
        return newObj;
      });

    this.setState({ buyingDivisionsOptions: buyingDivision });
    this.sellingopdivnumber = this.state.sellingDivisionsOptions[
      Number(value)
    ].sellingopdivnumber;
    this.sellingDivVal = this.state.sellingDivisionsOptions[Number(value)].text;
    let dateReq ={
      "SellingOpDivNumber" : this.sellingopdivnumber,
      "LocType": "COM"
    }
    postCdpDates(dateReq)
    .then(response => {
      this.cdpDateObj = response.data;
      let currentMonthFirstDay = new Date().setDate(1);
      const dateString = moment(currentMonthFirstDay).format('YYYY-MM-DD');
      this.cdpDateCalculation(currentMonthFirstDay, dateString);      
    })
    .catch(() => {
      toast({
        type: "error",
        title: "Error",
        description:
          "Unable to get date data due to technical difficulties"
      });
    });
  };

  handleBuyingDivChange = (e, { value }) => {
    this.buyingDivVal = this.state.buyingDivisionsOptions[Number(value)].text;
  };

  uniqBy = (a, key) => {
    let seen = new Set();
    return a.filter(item => {
      let k = key(item);
      return seen.has(k) ? false : seen.add(k);
    });
  };

  onChangeDepartment = (__, { value }) => {
    const dataHasBeenModified =
      !_.isNil(_.get(this, "state.department")) &&
      !_.isEqual(_.get(this, "state.department"), value);

    this.setState(
      {
        department: value
      },
      () =>
        getVendors(value).then(res => {
          if (res) {
            this.setState(
              state => {
                let vendors = sortBy(
                  res.data.map(vendor => _.chain({})
                    .extend(vendor, { value: vendor.RowKey, text: vendor.RowKey + "-" + vendor.Desc })
                    .omit(["Timestamp", "Desc", "RowKey", "PartitionKey"]).value()),
                  v => Number(v.value)
                );

                vendors = [_.chain(vendors).first().cloneDeep().extend({ text: "", title: "" }).omit("value").value(), ...vendors];

                return {
                  dataHasBeenModified:
                    dataHasBeenModified || _.get(state, "dataHasBeenModified"),
                  vendors: vendors,
                };
              },
              () => {
                const vendors = this.state.vendors;
                if (vendors && vendors.length) {
                  const vendor =
                    vendors.find(v => v.value === this.state.vendor) ||
                    vendors[0];
                  this.onChangeVendor(null, vendor, dataHasBeenModified);
                }
              }
            );
          }
        })
    );
  };

  onChangeVendor = (__, { value }, dataHasBeenModified = true) => {
    this.setState(state => ({
      dataHasBeenModified:
        dataHasBeenModified || _.get(state, "dataHasBeenModified"),
      vendor: value
    }), 
    () => {
      getPreferredTicketType(_.get(this, "state.department"), _.get(this, "state.vendor")).then(
        res => {
          this.setState({ticketTypeCode: res.data.ticketTypeCode})
      });
    });
  };

  loadDept_Vendor = () => {
    getDepartments().then(res => {
      if (res) {
        this.setState(
          state => {
            const departments = _.chain(res)
              .get("data")
              .map(({ RowKey, DeptName }) => ({
                value: RowKey,
                text: RowKey + "-" + DeptName
              }))
              .value();

            departments.unshift({
              text: "",
              title: ""
            });

            let departmentId = null;
            if (departments && departments.length) {
              const department =
                departments.find(v => v.value === state.department) ||
                departments[0];
              departmentId = department && department.value;
            }

            return {
              department: departmentId,
              departments: departments
            };
          },
          () =>
            this.onChangeDepartment(null, {
              value: this.state.department
            })
        );
      }
    })
  };

  getSellingDivOptions() {
    getSellingDiv().then(
      res => {
        if (res && res.data) {
          this.buyingSellingDiv = res.data;
          const sellingDiv = this.uniqBy(this.buyingSellingDiv, it => it.RowKey)
            .sort((a, b) => b.RowKey.localeCompare(a.RowKey))
            .map((obj, index) => {
              const newObj = {
                value: index,
                key: index,
                rowkeytext: obj.RowKey,
                text: obj.SellingDivName,
                sellingopdivnumber: obj.SellingOpDivNumber
              }
              return newObj;
            });

          let buyingDivision = this.buyingSellingDiv
            .filter(obj => obj.RowKey === sellingDiv[0].rowkeytext)
            .map((obj, index) => {
              const newObj = {
                value: index,
                key: index,
                rowkeytext: obj.PartitionKey,
                text: obj.BuyingDivName
              }
              return newObj;
            });
          this.setState({ buyingDivisionsOptions: buyingDivision });
          this.setState({ sellingDivisionsOptions: sellingDiv });
          this.sellingopdivnumber = sellingDiv[0].sellingopdivnumber;
          this.sellingDivVal = sellingDiv[0].text;
          this.buyingDivVal = buyingDivision[0].text;

          let dateReq ={
            "SellingOpDivNumber" : sellingDiv[0].sellingopdivnumber,
            "LocType": "COM"
          }
          postCdpDates(dateReq)
          .then(response => {
            this.cdpDateObj = response.data;
            let currentMonthFirstDay = new Date().setDate(1);
            let dateString = moment(currentMonthFirstDay).format('YYYY-MM-DD');
            const currDate = new Date();
            this.cdpDateCalculation(currDate, dateString);
          })
          .catch(() => {
            toast({
              type: "error",
              title: "Error",
              description:
                "Unable to get date data due to technical difficulties"
            });
          });
        }
      },
      r => {
        alert(
          "We are having problems trying to connect to the server. Please try again later."
        );
      }
    );
  }


  render() {
    if (this.state.vendor !== "") {
      if (this.state.goToProductDetail) {
        let cdpObj = {
          sellingDiv: this.sellingDivVal,
          buyingDiv: this.buyingDivVal,
          dept: this.state.department,
          vendor: this.state.vendor,
          date: this.state.calenderVal,
          SellingOpDivNumber: this.sellingopdivnumber,
          ticketTypeCode: this.state.ticketTypeCode,
          cdpSelectedDateObj: this.cdpSelectedDateObj
        };
        return (
          <Redirect
            to={{
              pathname: "/cdp-products/new",
              state: { cdpObj: cdpObj }
            }}
          />
        );
      }
    }

    return (
      <div>
      <Form size="small" className={cdpCreateStyle}>
        <div className="column">
        <div className="bscTitle">Selling</div>
          <Form.Select
            defaultValue={0}
            onChange={this.handleSellingDivChange}
            options={this.state.sellingDivisionsOptions}
            label="Div"
          />
        </div>
        <div className="column">
          <div className="bscTitle">Buying</div>
          <Form.Select
            defaultValue={0}
            onChange={this.handleBuyingDivChange}
            options={this.state.buyingDivisionsOptions}
            label="Div"
          />
          <Form.Select
            search
            options={defaultIds(this.state.departments)}
            onChange={this.onChangeDepartment}
            label="Dept"
          />
          <Form.Select
            search
            options={defaultIds(this.state.vendors)}
            onChange={this.onChangeVendor}
            label="Vendor"
          />
        </div>
        <div className="column">
          <div className="bscTitle">CDP Month</div>
          <div className="calStyle">
            <DatePicker
              showMonthYearPicker
              dateFormat="MM/yy"
              onChange={this.handleDateChange}
              selected={this.state.calenderVal}
              onKeyDown={e => {
                if (!_.includes([8, 17, 37, 39], e.keyCode) && !e.ctrlKey) {
                  e.preventDefault();
                }
              }}
            />
          </div>
        </div>
        <div className="column">
          <Ref innerRef={this.handleRef}>
            <Input
              style={cdpImportFileCss}
              type="file"
              disabled={!this.state.vendor}
              onInput={this.handleReadFile}
            ></Input>
          </Ref> 
        </div>
      </Form>
      <Dimmer active={this.state.loading} inverted>
        <Loader inverted>Loading...</Loader>
      </Dimmer>
      <ImportModal
      open={this.state.showImportModal}
      mappings={this.state.mappings}
      excelRows={this.state.excelRows}
      onCancel={this.handleImportCancellation}
      onImport={this.handleImport}
      onAddMapping={this.handleAddMapping}
      columnNames={cdpColumns}
      />
    </div>
    );
  }
}

const cdpImportFileCss = {
  top: "49px",
  height: "36px",
  font: "400 12px Lato"
};

function defaultIds(list) {
  return list.map(({ text, title, value }) => ({
    text,
    title,
    value: defaultTo(value, -1)
  }));
}

function createAutoMappings(headers, cdpColumns) {
  return headers.map(headerName => {
    const candidate = cdpColumns.find(
      col =>
        cleanTextToCompare(col.text) === cleanTextToCompare(headerName) ||
        cleanTextToCompare(col.value) === cleanTextToCompare(headerName)
    );

    if (candidate) {
      return createMapping(headerName, candidate.value);
    } else {
      return createMapping(headerName, skipColum.value);
    }
  });
}

function cleanTextToCompare(txt) {
  return String(txt)
    .toLowerCase()
    .replace(/[^A-Za-z]/g, "");
}

const cdpCreateStyle = css`
  & {
    display: flex;
    flex-direction: row;

    .column {
      flex: 1;
      padding: 5px;
    }

    .field {
      display: flex;
      justify-content: flex-end;
    }

    .input,
    .selection.dropdown {
      width: 200px !important;
      margin: 0px;
    }

    .input {
      padding: 0px;
    }

    .input > input {
      width: 100% !important;
    }

    .bscTitle {
      margin: 10px 10px 20px 10px;
      font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
      font-size: 14px;
      color: rgba(0,0,0,.87);
    }

    .calStyle {
      margin-left: 28px;
    }
    
    label {
      display: inline-block !important;
      margin-right: 5px !important;
      white-space: nowrap;
    }
  }
`;




// WEBPACK FOOTER //
// ./components/create-order/CreateCdpOrder.js